import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

const NestStructure = ({ model, isDetailed, showSpinner, hideSpinner }) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      buttonLabel={model.isHome() ? "Set Away" : "Set Home"}
      onTap={() => {
        showSpinner(
          `Setting '${model.get("name")}' to ${
            model.isHome() ? "Away" : "Home"
          }`
        );
        model.toggleOccupancy().then(hideSpinner, hideSpinner);
      }}
    />
  </CommonControlWrapper>
);
NestStructure.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default NestStructure;



// WEBPACK FOOTER //
// ./src/components/Controls/NestStructure.jsx